import { PublicClientApplication } from "@azure/msal-browser";
import { config } from '../config/env';

export const isBrowser = () => typeof window !== "undefined"

const loginRequest = {
    scopes: [config.azure.scope],
};

const msalConfig = {
        auth: {
        clientId: config.azure.clientId,
        authority: `https://login.microsoftonline.com/${config.azure.tenant}`,
        redirectUri: config.redirectUri,
        postLogoutRedirectUri: "/",
        },
};
    
export const msalInstance = new PublicClientApplication(msalConfig);
msalInstance.initialize();


export async function getToken() {
    const response = await msalInstance.acquireTokenSilent(loginRequest)

    if (response.accessToken) {
        console.log("Token acquired successfully.");
        return response.accessToken;
    } else {
        console.error("Failed to acquire token.");
        return null;
    }
}

export async function isLoggedIn() {
    const accounts = msalInstance.getAllAccounts();

    if (accounts.length === 0) {
        console.log("No accounts found. User is not logged in.");
        return false;
    }

    // Select account by tenant id
    const account = accounts.find(account => account.tenantId === config.azure.tenant);
    if (!account) {
        console.log("No matching account found. User is not logged in.");
        return false;
    }

    const token = await getToken();
    if (!token) {
        console.log("Failed to acquire token. User is not logged in.");
        return false;
    }

    // Verify if the account is an admin account
    const isAdmin = await verifyIfAdmin(token);
    if (!isAdmin) {
        console.log("User is not an admin.");
        return false;
    }

    console.log("User is logged in and is an admin.");
    return true;
}

export async function verifyIfAdmin(token) {
    try {
        const response = await fetch(`${config.apiBaseUrl}/api/v1/admin/verify`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'Cache-Control': 'no-cache'
            }
        });

        if (response.ok) {
            console.log("Admin status verified successfully.");
            return true; // Return true if the user is an admin
        } else {
            console.error("Failed to verify admin status.");
            return false; // Return false if the user is not an admin
        }
    } catch (error) {
        console.error("Error verifying admin status:", error);
        return false; // Return false in case of an error
    }
}

export function logout(){
    
    console.log("user logs out")
    msalInstance.logoutRedirect({
        account: msalInstance.getActiveAccount(),
        postLogoutRedirectUri: "/ava-admin/logout"
    })
    
}

async function logoutQuietly(loginHint) {
    console.log("User logs out quietly");
    await msalInstance.logoutPopup({
        logoutHint: loginHint,
    })
    localStorage.clear();
    sessionStorage.clear();
}

export async function login(){
    try {
        const response = await msalInstance.loginPopup(loginRequest);
        console.log("Login successful:", response);
        const isAdmin = await verifyIfAdmin(response.accessToken)
        if (!isAdmin) {
            await logoutQuietly(response.idTokenClaims.login_hint);
            return {
                isSuccessful : false,
                isAdmin: false,
                message: "You do not have admin privileges to access this application."
            }
        }

        const account = response.account;
        if (account) {
            localStorage.setItem("userName", account.name);
            msalInstance.setActiveAccount(account);
        }

        return {
            isSuccessful : true,
            message: "Login successful."
        };
    } catch (error) {
        return {
            isSuccessful : false,
            message: "Login failed."
        };
    }
};